/**
 * LABELS PDP (brand template) - behaviour for all labels-pdp sections.
 * Plain JavaScript, no dependencies. Modules:
 *   gallery   lightbox, mobile counter and progress rail
 *   buybox    option picker, size memory, stock-based scarcity, SKU, add to cart, pickup
 *   fit       Size & fit sheet (fit text, size memory, app block slot for Kiwi)
 *   faq       FAQ accordion in the buy box
 *   styled    looks, hotspots, size-aware "add look", complementary fallback
 *   trail     recently viewed with live "what changed"
 *   alsolike  related recommendations, skipping pieces already on the page, in the visitor's department
 *   brand     brand links to the men or women brand page of the visitor's department
 *   ask       question chips that open buy box FAQ items, optional live answers from the Maison commerce app
 *
 * Visitor data lives in localStorage (keys labels.*). Everything fails soft when storage is blocked.
 * Strings can be overridden with window.LabelsPdpStrings = { selectSize: '...' } before this file loads;
 * snippets/labels-pdp-i18n.liquid sets them from the locale files (labels_pdp.js.*).
 */
(function () {
  'use strict';
  if (window.__labelsPdp) return;
  window.__labelsPdp = true;

  var KEY_SIZE = 'labels.sizeHistory';
  var KEY_TRAIL = 'labels.trail';
  var KEY_SIZE_LINE_OFF = 'labels.sizeCardDismissed';

  var S = Object.assign({
    selectSize: 'Select size',
    selectOption: 'Select an option',
    addToCart: 'Add to cart',
    adding: 'Adding…',
    soldOut: 'Sold out',
    yourSize: 'Your size',
    sizeLine: 'You chose {size} in {type} at {brands} before.',
    sizeLineNoBrand: 'You chose {size} in {type} before.',
    usualSoldOut: 'Your usual size {size} is sold out in this item.',
    onlyLeft: 'Only {size} left',
    lastOne: 'Last one in {size}',
    onlyQty: 'Only {qty} left in {size}',
    onlyQtyNoSize: 'Only {qty} left',
    lastPiece: 'Last piece',
    qtyLeft: '{qty} left',
    closeZoom: 'Close zoom',
    pickupAt: 'Pickup available at {location}',
    pickupNone: 'Not available for pickup in this size',
    added: 'Added to cart',
    viewCart: 'View cart',
    addedLook: 'Look added to cart',
    cartError: 'We could not add this to your cart. Please try again.',
    selectSizeFor: 'Select a size for {name}',
    nothingToAdd: 'Nothing available to add from this look.',
    inYourSize: 'In your size {size}',
    thisPiece: 'This piece',
    inStock: 'In stock',
    askThinking: 'Thinking…',
    askError: 'Sorry, we could not answer that right now. Ask us in store or via chat.'
  }, window.LabelsPdpStrings || {});

  /* ---------------------------------------------------------------- utils */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function t(str, vars) {
    return String(str).replace(/\{(\w+)\}/g, function (m, k) { return vars && vars[k] != null ? vars[k] : m; });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  var store = {
    get: function (k, d) { try { var v = window.localStorage.getItem(k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { window.localStorage.setItem(k, JSON.stringify(v)); } catch (e) { /* storage blocked */ } }
  };
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function fmt(cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency', currency: cur, minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2
      }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }
  /** ISO 3166 code -> country name in the storefront language ("IT" -> "Italy" / "Italië"). */
  // CLDR uses official names where shoppers expect the common one
  var COUNTRY_NAMES = { en: { TR: 'Turkey' } };
  function countryName(code) {
    var lang = document.documentElement.lang || 'en';
    var own = COUNTRY_NAMES[lang.split('-')[0].toLowerCase()];
    if (own && own[code]) return own[code];
    try {
      return new Intl.DisplayNames([lang], { type: 'region' }).of(code) || code;
    } catch (e) { return code; }
  }
  function track(name, detail) {
    var payload = Object.assign({ event: name }, detail || {});
    try { (window.dataLayer = window.dataLayer || []).push(payload); } catch (e) { /* ignore */ }
    try { document.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); } catch (e) { /* ignore */ }
  }
  var productCache = {};
  function fetchProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(root() + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }
  function cartAdd(items) {
    return fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw new Error(data.description || data.message || 'cart error');
        syncCart();
        return data;
      });
    });
  }
  function syncCart() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { resource: cart, sourceId: 'labels-pdp', data: { itemCount: cart.item_count, source: 'labels-pdp' } }
        }));
      })
      .catch(function () {});
  }
  function toast(html, el) {
    el = el || $('[data-toast]');
    if (!el) return;
    el.innerHTML = html;
    el.hidden = false;
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { el.hidden = true; }, 6000);
  }
  function cartUrl() { var r = $('[data-cart-url]'); return (r && r.dataset.cartUrl) || '/cart'; }

  /* ----------------------------------------------------- size memory logic */
  function sizeSystem(v) {
    v = String(v || '').trim().toUpperCase();
    if (/^(XXXS|XXS|XS|S|M|L|XL|XXL|XXXL|2XL|3XL|4XL|ONE SIZE|OS|O\/S)$/.test(v)) return 'alpha';
    if (/^\d{2}\s*\/\s*\d{2}$/.test(v)) return 'waistlength';
    var m = v.match(/^(EU|IT|FR|UK|US|JP|DE)?\s?(\d{1,2}(\.\d)?)$/);
    if (m) return 'numeric:' + (m[1] || '');
    return 'other';
  }
  function readHistory() { return store.get(KEY_SIZE, []); }
  function recordSize(entry) {
    if (!entry || !entry.value) return;
    var h = readHistory();
    h.unshift({ type: String(entry.type || '').toLowerCase(), typeLabel: entry.type || '', brand: entry.brand || '', value: entry.value, system: sizeSystem(entry.value), t: Date.now() });
    store.set(KEY_SIZE, h.slice(0, 40));
  }
  /** Suggest a size for a product type among the given size values. */
  function suggestSize(type, values) {
    var hist = readHistory();
    if (!hist.length || !values.length) return null;
    var systems = {};
    values.forEach(function (v) { systems[sizeSystem(v)] = true; });
    var typeLc = String(type || '').toLowerCase();
    var pool = hist.filter(function (h) { return systems[h.system] && h.type === typeLc && values.indexOf(h.value) > -1; });
    if (!pool.length) {
      // alpha sizes (S/M/L) carry over between categories, numeric and waist/length sizes do not
      pool = hist.filter(function (h) { return h.system === 'alpha' && systems.alpha && values.indexOf(h.value) > -1; });
    }
    if (!pool.length) return null;
    var score = {};
    pool.forEach(function (h, i) { score[h.value] = (score[h.value] || 0) + 1 / (1 + i * 0.25); });
    var best = Object.keys(score).sort(function (a, b) { return score[b] - score[a]; })[0];
    var brands = [];
    pool.forEach(function (h) { if (h.value === best && h.brand && brands.indexOf(h.brand) === -1) brands.push(h.brand); });
    return { value: best, brands: brands.slice(0, 2), type: type };
  }
  /** "You chose L in T-shirts at Dries Van Noten before" for the line above the chips and the fit sheet. */
  function sizeLineText(sug, type) {
    var vars = { size: sug.value, type: type || 'this category', brands: sug.brands.join(' & ') };
    return t(sug.brands.length ? S.sizeLine : S.sizeLineNoBrand, vars);
  }

  /* -------------------------------------------------------------- gallery */
  function initGallery(rootEl) {
    var gallery = $('[data-gallery]', rootEl);
    if (!gallery) return;
    var items = $$('[data-gallery-item]', gallery);
    var counter = $('[data-counter]', gallery);
    var rail = $('[data-rail]', gallery);
    if (rail) rail.innerHTML = items.map(function () { return '<span></span>'; }).join('');

    function setActive(i) {
      if (counter) counter.textContent = (i + 1) + ' / ' + items.length;
      if (rail) $$('span', rail).forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
    }
    setActive(0);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) setActive(items.indexOf(e.target)); });
      }, { threshold: 0.55 });
      items.forEach(function (el) { io.observe(el); });
      new IntersectionObserver(function (entries) {
        gallery.classList.toggle('is-inview', entries[0].isIntersecting);
      }, { threshold: 0.05 }).observe(gallery);
    }

    var swipe = initSwipe(rootEl, gallery, items);

    // lightbox
    var box = $('[data-lightbox]', rootEl);
    if (!box || typeof box.showModal !== 'function') return;
    var zoomables = items.filter(function (el) { return el.dataset.zoomSrc; });
    var img = $('[data-lightbox-img]', box);
    var current = 0;
    function show(i) {
      current = (i + zoomables.length) % zoomables.length;
      img.src = zoomables[current].dataset.zoomSrc;
      img.alt = zoomables[current].dataset.zoomAlt || '';
    }
    zoomables.forEach(function (el, i) {
      el.addEventListener('click', function () {
        if (swipe && swipe.blocksLightbox()) return;
        show(i); box.showModal(); track('labels_gallery_zoom', { index: i + 1 });
      });
    });
    $('[data-lightbox-close]', box).addEventListener('click', function () { box.close(); });
    $('[data-lightbox-prev]', box).addEventListener('click', function () { show(current - 1); });
    $('[data-lightbox-next]', box).addEventListener('click', function () { show(current + 1); });
    box.addEventListener('click', function (e) { if (e.target === box) box.close(); });
    box.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });
  }

  /**
   * Mobile gallery (below 750px): horizontal swipe, a scrub tape that follows the scroll position and can be dragged,
   * (hold-to-loupe is off so long-press can save the image) and double tap to zoom in place (the zoom point follows the finger).
   * Also measures the space above the gallery (--lp-head) and the theme's fixed bottom menu (--lp-dock).
   * Returns { blocksLightbox() }: on mobile double tap zooms instead, and a click right after a loupe or zoom is ignored.
   */
  function initSwipe(rootEl, gallery, items) {
    var stage = $('[data-stage]', rootEl);
    var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : { matches: false };
    var scrub = $('[data-scrub]', rootEl);
    var segs = scrub ? $$('.labels-scrub__seg', scrub) : [];
    var nowEl = scrub && $('[data-scrub-now]', scrub);
    var capEl = scrub && $('[data-scrub-cap]', scrub);
    var track_ = scrub && $('[data-scrub-track]', scrub);
    var n = items.length;
    var raf = 0;
    var index = -1;
    var touched = false;
    var capTimer = 0;
    var lastUse = 0;

    // Slide height comes from the real screen height, measured only when the width changes:
    // iOS changes innerHeight while its toolbar collapses during scrolling and the gallery must not jump then.
    var measuredW = 0;
    function measure(force) {
      var w = window.innerWidth;
      if (!force && w === measuredW) return;
      measuredW = w;
      var docEl = document.documentElement;
      var dock = document.querySelector('.mm-dock');
      var dockH = dock && getComputedStyle(dock).display !== 'none' ? dock.getBoundingClientRect().height : 0;
      var head = Math.max(0, gallery.getBoundingClientRect().top + (window.scrollY || window.pageYOffset || 0));
      docEl.style.setProperty('--lp-dock', dockH + 'px');
      docEl.style.setProperty('--lp-head', head + 'px');
      gallery.style.setProperty('--lp-slide-h', Math.max(320, window.innerHeight - head - dockH + 2) + 'px');
    }
    measure(true);
    window.addEventListener('load', function () { measure(true); });

    // Overlays on the images only show while the top edge of the photo is fully in view:
    // they leave as soon as scrolling down cuts the top off and return once it lines up again.
    if (stage) {
      var syncQuiet = function () {
        stage.classList.toggle('is-quiet', mq.matches && gallery.getBoundingClientRect().top < -1);
      };
      window.addEventListener('scroll', syncQuiet, { passive: true });
      window.addEventListener('resize', syncQuiet);
      syncQuiet();
    }

    function setIndex(i) {
      if (i === index) return;
      var first = index === -1;
      index = i;
      if (nowEl) nowEl.textContent = String(i + 1);
      if (!first && i !== 0) gallery.classList.add('is-clean');
      if (capEl) {
        var text = items[i].dataset.caption || '';
        if (first) capEl.textContent = text;
        else {
          capEl.classList.add('is-swap');
          clearTimeout(capTimer);
          capTimer = setTimeout(function () { capEl.textContent = text; capEl.classList.remove('is-swap'); }, 160);
        }
      }
      if (!first && touched) {
        if (navigator.vibrate) { try { navigator.vibrate(4); } catch (e) { /* not allowed */ } }
        track('labels_gallery_swipe', { index: i + 1 });
      }
    }
    function update() {
      raf = 0;
      if (!mq.matches) return;
      var w = gallery.clientWidth || 1;
      var pos = gallery.scrollLeft / w;
      segs.forEach(function (s, k) { s.style.setProperty('--f', Math.max(0, Math.min(1, pos + 1 - k)).toFixed(4)); });
      setIndex(Math.max(0, Math.min(n - 1, Math.round(pos))));
    }
    function schedule() { if (!raf) raf = requestAnimationFrame(update); }
    gallery.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', function () { measure(false); schedule(); });
    gallery.addEventListener('touchstart', function () { touched = true; }, { passive: true, once: true });
    update();

    // scrub tape: drag along it to fly through the images, release to snap to the nearest one
    if (track_) {
      var dragging = false;
      var scrubTo = function (e) {
        var r = track_.getBoundingClientRect();
        var f = Math.max(0, Math.min(1, (e.clientX - r.left) / r.width));
        var target = Math.max(0, Math.min(n - 1, f * n - 0.5));
        gallery.scrollLeft = target * gallery.clientWidth;
      };
      track_.addEventListener('pointerdown', function (e) {
        if (!mq.matches) return;
        dragging = true;
        touched = true;
        try { track_.setPointerCapture(e.pointerId); } catch (err) { /* ignore */ }
        if (stage) stage.classList.add('is-scrubbing');
        scrubTo(e);
        track('labels_gallery_scrub', {});
      });
      track_.addEventListener('pointermove', function (e) { if (dragging) scrubTo(e); });
      var end = function () {
        if (!dragging) return;
        dragging = false;
        if (stage) stage.classList.remove('is-scrubbing');
        var w = gallery.clientWidth;
        gallery.scrollTo({ left: Math.round(gallery.scrollLeft / w) * w, behavior: 'smooth' });
      };
      track_.addEventListener('pointerup', end);
      track_.addEventListener('pointercancel', end);
    }

    /* ---- loupe ---- */
    var lens = $('[data-loupe]', rootEl);
    var ZOOM = 2.5;
    var R = 84;
    var LIFT = 112;
    var holdTimer = 0;
    var loupe = null;
    var startX = 0;
    var startY = 0;
    var startT = 0;
    var moved = false;

    /** Rendered box of an object-fit: cover image, in viewport coordinates. */
    function coverBox(img) {
      var r = img.getBoundingClientRect();
      var nw = img.naturalWidth || r.width;
      var nh = img.naturalHeight || r.height;
      var scale = Math.max(r.width / nw, r.height / nh);
      var w = nw * scale;
      var h = nh * scale;
      return { x0: r.left + (r.width - w) / 2, y0: r.top + (r.height - h) / 2, w: w, h: h };
    }
    /** The lens floats above the finger and magnifies exactly what is under its own centre. */
    function placeLens(x, y) {
      var g = coverBox(loupe.img);
      var lx = Math.max(R + 4, Math.min(window.innerWidth - R - 4, x));
      var ly = Math.max(R + 4, y - LIFT);
      var fx = Math.max(0, Math.min(1, (lx - g.x0) / g.w));
      var fy = Math.max(0, Math.min(1, (ly - g.y0) / g.h));
      lens.style.setProperty('--lx', lx + 'px');
      lens.style.setProperty('--ly', ly + 'px');
      lens.style.backgroundSize = (g.w * ZOOM) + 'px ' + (g.h * ZOOM) + 'px';
      lens.style.backgroundPosition = (R - fx * g.w * ZOOM) + 'px ' + (R - fy * g.h * ZOOM) + 'px';
    }
    function startLoupe(item, x, y) {
      var img = $('img', item);
      if (!img || !lens) return;
      loupe = { item: item, img: img };
      gallery.classList.add('is-loupe');
      lens.style.backgroundImage = 'url("' + (img.currentSrc || img.src) + '")';
      var hi = new Image();
      hi.onload = function () { if (loupe && loupe.item === item) lens.style.backgroundImage = 'url("' + hi.src + '")'; };
      hi.src = item.dataset.zoomSrc;
      lens.hidden = false;
      lens.classList.add('is-moving');
      placeLens(x, y);
      void lens.offsetWidth;
      lens.classList.remove('is-moving');
      lens.classList.add('is-on');
      if (navigator.vibrate) { try { navigator.vibrate(8); } catch (e) { /* not allowed */ } }
      track('labels_gallery_loupe', { index: items.indexOf(item) + 1 });
    }
    function stopLoupe() {
      clearTimeout(holdTimer);
      if (!loupe) return;
      loupe = null;
      lastUse = Date.now();
      gallery.classList.remove('is-loupe');
      lens.classList.remove('is-on');
      setTimeout(function () { if (!loupe) lens.hidden = true; }, 200);
    }

    /* ---- double tap zoom ---- */
    var zoomed = null;
    var lastTap = { t: 0, x: 0, y: 0 };
    var singleTap = 0;
    function setOrigin(item, x, y) {
      var r = item.getBoundingClientRect();
      item.style.setProperty('--zx', (Math.max(0, Math.min(1, (x - r.left) / r.width)) * 100).toFixed(2) + '%');
      item.style.setProperty('--zy', (Math.max(0, Math.min(1, (y - r.top) / r.height)) * 100).toFixed(2) + '%');
    }
    function zoomIn(item, x, y) {
      var img = $('img', item);
      if (!img) return;
      var z = $('.labels-zoomimg', item);
      if (!z) {
        z = document.createElement('img');
        z.className = 'labels-zoomimg';
        z.alt = '';
        z.src = img.currentSrc || img.src;
        item.appendChild(z);
        var hi = new Image();
        hi.onload = function () { z.src = hi.src; };
        hi.src = item.dataset.zoomSrc;
      }
      var close = $('.labels-zoomclose', item);
      if (!close) {
        close = document.createElement('button');
        close.type = 'button';
        close.className = 'labels-zoomclose';
        close.setAttribute('aria-label', S.closeZoom);
        close.addEventListener('click', function (e) { e.stopPropagation(); zoomOut(); });
        item.appendChild(close);
      }
      setOrigin(item, x, y);
      void z.offsetWidth;
      item.classList.add('is-zoomed');
      gallery.classList.add('is-zoomed');
      zoomed = item;
      track('labels_gallery_doubletap_zoom', { index: items.indexOf(item) + 1 });
    }
    function zoomOut() {
      if (!zoomed) return;
      zoomed.classList.remove('is-zoomed', 'is-panning');
      gallery.classList.remove('is-zoomed');
      zoomed = null;
      lastUse = Date.now();
    }

    gallery.addEventListener('touchstart', function (e) {
      if (!mq.matches) return;
      if (e.touches.length !== 1) { stopLoupe(); return; }
      var t0 = e.touches[0];
      startX = t0.clientX;
      startY = t0.clientY;
      startT = Date.now();
      moved = false;
      var item = e.target.closest && e.target.closest('[data-gallery-item]');
      if (zoomed) {
        if (item === zoomed && !(e.target.closest && e.target.closest('.labels-zoomclose'))) zoomed.classList.add('is-panning');
        return;
      }
      /* no hold-to-loupe: a long press must stay free for the native "Save image" menu */
    }, { passive: true });

    gallery.addEventListener('touchmove', function (e) {
      if (!mq.matches) return;
      var t0 = e.touches[0];
      if (Math.abs(t0.clientX - startX) > 8 || Math.abs(t0.clientY - startY) > 8) {
        moved = true;
        clearTimeout(holdTimer);
      }
      if (loupe) {
        e.preventDefault();
        lens.classList.add('is-moving');
        placeLens(t0.clientX, t0.clientY);
      } else if (zoomed) {
        e.preventDefault();
        setOrigin(zoomed, t0.clientX, t0.clientY);
      }
    }, { passive: false });

    gallery.addEventListener('touchend', function (e) {
      if (!mq.matches) return;
      if (loupe) { stopLoupe(); return; }
      clearTimeout(holdTimer);
      if (zoomed) zoomed.classList.remove('is-panning');
      var t0 = e.changedTouches[0];
      var item = e.target.closest && e.target.closest('[data-gallery-item]');
      if (moved || !t0 || !item || Date.now() - startT > 250) return;
      if (e.target.closest && e.target.closest('.labels-zoomclose')) return;
      var now = Date.now();
      if (now - lastTap.t < 320 && Math.abs(t0.clientX - lastTap.x) < 30 && Math.abs(t0.clientY - lastTap.y) < 30) {
        lastTap.t = 0;
        clearTimeout(singleTap);
        if (e.cancelable) e.preventDefault();
        if (zoomed) zoomOut();
        else if (item.dataset.zoomSrc) zoomIn(item, t0.clientX, t0.clientY);
        return;
      }
      lastTap = { t: now, x: t0.clientX, y: t0.clientY };
      clearTimeout(singleTap);
      if (!zoomed) {
        singleTap = setTimeout(function () {
          var clean = gallery.classList.toggle('is-clean');
          track('labels_gallery_info', { shown: !clean });
        }, 330);
      }
    });
    gallery.addEventListener('touchcancel', function () { stopLoupe(); if (zoomed) zoomed.classList.remove('is-panning'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') zoomOut(); });
    gallery.addEventListener('scroll', function () { if (zoomed && !mq.matches) zoomOut(); }, { passive: true });

    return {
      blocksLightbox: function () { return mq.matches || !!loupe || !!zoomed || Date.now() - lastUse < 400; }
    };
  }

  /* -------------------------------------------------------- option thumb */
  /** Moves the sliding thumb of an option grid onto its checked chip. */
  function placeThumb(fs, instant) {
    var grid = $('[data-option-grid]', fs);
    var thumb = grid && $('[data-option-thumb]', grid);
    if (!thumb) return;
    grid.classList.add('has-thumb');
    var input = $('input:checked', grid);
    var chip = input && input.closest('[data-chip]');
    if (!chip) { thumb.classList.remove('is-on'); return; }
    if (instant || !thumb.classList.contains('is-on')) thumb.classList.add('is-instant');
    thumb.style.setProperty('--tx', chip.offsetLeft + 'px');
    thumb.style.setProperty('--ty', chip.offsetTop + 'px');
    thumb.style.setProperty('--tw', chip.offsetWidth + 'px');
    thumb.style.setProperty('--th', chip.offsetHeight + 'px');
    if (thumb.classList.contains('is-instant')) {
      void thumb.offsetWidth;
      thumb.classList.remove('is-instant');
    }
    thumb.classList.add('is-on');
  }

  /* ---------------------------------------------------------------- stock */
  /**
   * Stock line for the buy box. qty is only present on variants with tracked, low stock (see labels-pdp-main.liquid).
   * onlySize: the single size still available given the other selections, or null.
   */
  function stockMessage(variants, sizeIdx, v, onlySize) {
    if (v && v.available && v.qty) {
      var size = sizeIdx > -1 ? v.options[sizeIdx] : '';
      if (v.qty === 1) return size ? t(S.lastOne, { size: size }) : S.lastPiece;
      return size ? t(S.onlyQty, { qty: v.qty, size: size }) : t(S.onlyQtyNoSize, { qty: v.qty });
    }
    if (!v) {
      var avail = variants.filter(function (x) { return x.available; });
      if (avail.length === 1 && avail[0].qty === 1) return S.lastPiece;
    }
    if (onlySize) return t(S.onlyLeft, { size: onlySize });
    return null;
  }
  /** Summed low stock of the given available variants, or 0 when any of them is untracked or plentiful. */
  function lowQty(list, threshold) {
    if (!list.length) return 0;
    var sum = 0;
    for (var i = 0; i < list.length; i++) {
      if (!list[i].qty) return 0;
      sum += list[i].qty;
    }
    return sum <= threshold ? sum : 0;
  }

  /* --------------------------------------------------------------- buybox */
  function initBuybox(rootEl) {
    var variantsEl = $('[data-variants]', rootEl);
    if (!variantsEl) return null;
    var variants = JSON.parse(variantsEl.textContent);
    var form = $('[data-form]', rootEl);
    var optionEls = $$('[data-option]', rootEl);
    var sizeIdx = -1;
    optionEls.forEach(function (fs, i) { if (fs.dataset.isSize === 'true') sizeIdx = i; });
    var atc = $('[data-atc]', rootEl);
    var atcLabel = $('[data-atc-label]', rootEl);
    var errorEl = $('[data-error]', rootEl);
    var stockEl = $('[data-stock]', rootEl);
    var sel = optionEls.map(function (fs) {
      var c = $('input:checked', fs);
      return c ? c.value : null;
    });
    var suggestion = null;
    var vendor = rootEl.dataset.productVendor;
    var type = rootEl.dataset.productType;
    var lowStock = parseInt(rootEl.dataset.lowStock, 10) || 2;

    function findVariant() {
      if (!optionEls.length) return variants[0] || null;
      if (sel.some(function (v) { return v == null; })) return null;
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      })[0] || null;
    }
    function sizeValue() { return sizeIdx > -1 ? sel[sizeIdx] : null; }

    // country of origin: InventoryItem.countryCodeOfOrigin through the Maison commerce endpoint (Liquid cannot read it)
    var originRow = $('[data-origin-row]', rootEl);
    var originData = null;
    function renderOrigin(v) {
      if (!originRow) return;
      var code = null;
      if (originData) code = v ? originData.variants[String(v.id)] || null : originData.country || null;
      if (code) $('[data-origin]', originRow).textContent = countryName(code);
      originRow.hidden = !code;
    }
    if (originRow && rootEl.dataset.originEndpoint) {
      var originUrl = rootEl.dataset.originEndpoint + (rootEl.dataset.originEndpoint.indexOf('?') > -1 ? '&' : '?') +
        'handle=' + encodeURIComponent(rootEl.dataset.productHandle);
      fetch(originUrl, { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d || !d.ok) return;
          originData = { country: d.country, variants: d.variants || {} };
          renderOrigin(findVariant());
        })
        .catch(function () { /* row stays hidden */ });
    }

    function showError(msg) { if (!errorEl) return; errorEl.textContent = msg || ''; errorEl.hidden = !msg; }

    function refresh() {
      var v = findVariant();
      var onlySize = null;
      showError('');

      optionEls.forEach(function (fs, i) {
        var availableCount = 0;
        var lastAvailable = '';
        $$('[data-chip]', fs).forEach(function (chip) {
          var val = $('input', chip).value;
          var matches = variants.filter(function (x) {
            return x.available && x.options[i] === val && sel.every(function (s, j) { return j === i || s == null || x.options[j] === s; });
          });
          var ok = matches.length > 0;
          if (ok) { availableCount++; lastAvailable = val; }
          chip.classList.toggle('is-soldout', !ok);
          var sub = $('[data-sub]', chip);
          if (sub) {
            var low = ok && i === sizeIdx && sel[i] === val ? lowQty(matches, lowStock) : 0;
            var text = '';
            if (!ok) text = S.soldOut;
            else if (i === sizeIdx && suggestion && suggestion.value === val) text = S.yourSize;
            else if (low) text = t(S.qtyLeft, { qty: low });
            sub.textContent = text;
            sub.classList.toggle('is-low', !!low && text !== S.yourSize);
          }
        });
        if (i === sizeIdx && availableCount === 1) onlySize = lastAvailable;
        placeThumb(fs);
      });
      // the line has done its job once the suggested size is picked; the chip keeps its "Your size" tag
      if (sizeLine && suggestion && sizeValue() === suggestion.value) sizeLine.hidden = true;

      if (stockEl) {
        var stockText = stockMessage(variants, sizeIdx, v, onlySize);
        stockEl.textContent = stockText || '';
        stockEl.hidden = !stockText;
      }

      // price
      var priceEl = $('[data-price]', rootEl);
      var mirror = $('[data-price-mirror]', rootEl);
      var compare = $('[data-compare]', rootEl);
      if (v) {
        if (priceEl) priceEl.textContent = v.price;
        if (mirror) mirror.textContent = v.price;
        if (compare) { compare.textContent = v.compare || ''; compare.hidden = !v.compare; }
      }

      renderOrigin(v);

      // SKU in the spec list
      var skuRow = $('[data-sku-row]', rootEl);
      if (skuRow) {
        var skuFrom = v || variants.filter(function (x) { return x.available; })[0] || variants[0];
        var sku = skuFrom ? skuFrom.sku : null;
        if (sku) $('[data-sku]', skuRow).textContent = sku;
        skuRow.hidden = !sku;
      }

      // add to cart label
      var label = S.addToCart;
      var disabled = false;
      if (!v) label = sizeIdx > -1 ? S.selectSize : S.selectOption;
      else if (!v.available) { label = S.soldOut; disabled = true; }
      if (atcLabel) atcLabel.textContent = label;
      if (atc) atc.disabled = disabled;

      // pickup row
      var row = $('[data-pickup-row]', rootEl);
      if (row && v) {
        var l = $('[data-pickup-label]', row);
        var tm = $('[data-pickup-time]', row);
        if (v.pickup) {
          l.textContent = t(S.pickupAt, { location: v.pickup.location });
          tm.textContent = v.pickup.time || '';
          row.hidden = false;
        } else if (v.available && variants.some(function (x) { return x.pickup; })) {
          l.textContent = S.pickupNone;
          tm.textContent = '';
          row.hidden = false;
        }
      }

      if (v && optionEls.length && window.history && history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          history.replaceState(null, '', u.toString());
        } catch (e) { /* ignore */ }
      }
      document.dispatchEvent(new CustomEvent('labels:variant-change', { detail: { variant: v, size: sizeValue(), productId: rootEl.dataset.productId } }));
    }

    function selectValue(optIndex, value) {
      var fs = optionEls[optIndex];
      if (!fs) return false;
      var input = $$('input', fs).filter(function (i) { return i.value === value; })[0];
      if (!input) return false;
      input.checked = true;
      sel[optIndex] = value;
      return true;
    }

    optionEls.forEach(function (fs, i) {
      fs.addEventListener('change', function (e) {
        if (e.target && e.target.matches('input')) {
          sel[i] = e.target.value;
          if (i === sizeIdx) track('labels_size_select', { size: e.target.value, source: 'chip' });
          refresh();
        }
      });
    });

    // variant from URL: product cards always link one, so it sets colour and other options but never the size
    try {
      var vid = new URL(window.location.href).searchParams.get('variant');
      var fromUrl = vid && variants.filter(function (x) { return String(x.id) === vid; })[0];
      if (fromUrl && optionEls.length) fromUrl.options.forEach(function (o, i) { if (i !== sizeIdx) selectValue(i, o); });
    } catch (e) { /* ignore */ }

    // size memory
    var sizeLine = $('[data-size-line]', rootEl);
    if (sizeIdx > -1) {
      var sizeValues = $$('input', optionEls[sizeIdx]).map(function (i) { return i.value; });
      suggestion = suggestSize(type, sizeValues);
      if (suggestion) {
        var sugAvailable = variants.some(function (x) { return x.available && x.options[sizeIdx] === suggestion.value; });
        track('labels_size_suggested', { size: suggestion.value, available: sugAvailable });
        if (sizeLine && !store.get(KEY_SIZE_LINE_OFF, false)) {
          $('[data-size-line-text]', sizeLine).textContent = sugAvailable
            ? sizeLineText(suggestion, type)
            : t(S.usualSoldOut, { size: suggestion.value });
          var closeBtn = $('[data-size-line-close]', sizeLine);
          if (closeBtn) closeBtn.addEventListener('click', function () {
            sizeLine.hidden = true;
            store.set(KEY_SIZE_LINE_OFF, true);
            track('labels_size_line_dismiss', { size: suggestion.value });
          });
          sizeLine.hidden = false;
        }
      }
    }
    refresh();
    if ('ResizeObserver' in window) {
      optionEls.forEach(function (fs) {
        var grid = $('[data-option-grid]', fs);
        if (grid) new ResizeObserver(function () { placeThumb(fs, true); }).observe(grid);
      });
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { optionEls.forEach(function (fs) { placeThumb(fs, true); }); });

    function pendingMessage() {
      showError(sizeIdx > -1 ? S.selectSize : S.selectOption);
      var target = optionEls.filter(function (fs, i) { return sel[i] == null; })[0] || optionEls[0];
      if (target && target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    function addCurrent() {
      var v = findVariant();
      if (!v) { pendingMessage(); return; }
      if (!v.available) return;
      if (atc) atc.disabled = true;
      if (atcLabel) atcLabel.textContent = S.adding;
      cartAdd([{ id: v.id, quantity: 1 }]).then(function (cart) {
        if (sizeValue()) recordSize({ type: type, brand: vendor, value: sizeValue() });
        track('labels_add_to_cart', { handle: rootEl.dataset.productHandle, variant_id: v.id, size: sizeValue() });
        document.dispatchEvent(new CustomEvent('labels:cart-add', { detail: { items: cart.items || [cart], source: 'pdp' } }));
        if (rootEl.dataset.afterAdd === 'cart_page') { window.location.href = cartUrl(); return; }
        toast('<span>' + esc(S.added) + '</span><a href="' + esc(cartUrl()) + '">' + esc(S.viewCart) + '</a>', $('[data-atc-toast]', rootEl));
      }).catch(function (err) {
        showError(err && err.message && err.message.length < 140 ? err.message : S.cartError);
      }).then(function () { refresh(); });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); addCurrent(); });
    // snapshot for the trail
    var availVals = variants.filter(function (x) { return x.available; }).map(function (x) { return x.options[sizeIdx > -1 ? sizeIdx : 0]; });
    var first = variants.filter(function (x) { return x.available; })[0] || variants[0];
    trackCurrent({
      handle: rootEl.dataset.productHandle, title: rootEl.dataset.productTitle, vendor: vendor,
      img: rootEl.dataset.productImage, price: first ? first.priceCents : 0, avail: availVals, t: Date.now(),
      dept: rootEl.dataset.productDept || ''
    });

    return { getVariant: findVariant, getSize: sizeValue, getSuggestion: function () { return suggestion; } };
  }

  /* ------------------------------------------------------------ fit sheet */
  /** Size & fit sheet: fit text, the visitor's size memory and the app block slot (Kiwi) from labels-pdp-main.liquid. */
  function initFitSheet(rootEl, buybox) {
    var sheet = $('[data-fit-sheet]', rootEl);
    var open = $('[data-fit-open]', rootEl);
    if (!sheet || !open || typeof sheet.showModal !== 'function') return;
    var memory = $('[data-fit-memory]', sheet);
    var sug = buybox && buybox.getSuggestion();
    if (memory && sug) {
      memory.textContent = sizeLineText(sug, rootEl.dataset.productType);
      memory.hidden = false;
    }
    open.addEventListener('click', function () {
      sheet.showModal();
      track('labels_fit_sheet_open', { handle: rootEl.dataset.productHandle });
    });
    var close = $('[data-fit-close]', sheet);
    if (close) close.addEventListener('click', function () { sheet.close(); });
    sheet.addEventListener('click', function (e) { if (e.target === sheet) sheet.close(); });
  }

  function trackCurrent(entry) {
    var all = store.get(KEY_TRAIL, []);
    var old = all.filter(function (x) { return x.handle === entry.handle; })[0];
    entry.views = ((old && old.views) || (old ? 1 : 0)) + 1; // the brand PLP shows "Viewed twice"
    var list = all.filter(function (x) { return x.handle !== entry.handle; });
    list.unshift(entry);
    store.set(KEY_TRAIL, list.slice(0, 20));
  }

  /* ------------------------------------------------------------- styled with */
  /** sizeName: one option name or a comma-separated list (the size option name in every live language). */
  function sizeOptionIndex(product, sizeName) {
    var names = String(sizeName || '').toLowerCase().split(',').map(function (n) { return n.trim(); }).filter(Boolean);
    var idx = -1;
    (product.options || []).forEach(function (o, i) {
      var name = typeof o === 'string' ? o : o.name;
      if (idx === -1 && names.indexOf(String(name).toLowerCase()) > -1) idx = i;
    });
    return idx;
  }
  function variantSizeValue(v, idx) { return idx > -1 ? v['option' + (idx + 1)] : v.title; }

  /**
   * PLP product card (the Horizon _product-card, same block settings as the collection page) from
   * /products/{handle}?view=labels-card (templates/product.labels-card.json). Resolves to a fresh <li data-lp-card>
   * per call, or null when the product is gone or the request fails.
   */
  var cardHtml = {};
  function loadCard(handle) {
    if (!cardHtml[handle]) {
      cardHtml[handle] = fetch(root() + 'products/' + encodeURIComponent(handle) + '?view=labels-card')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    }
    return cardHtml[handle].then(function (html) {
      var tpl = document.createElement('template');
      tpl.innerHTML = html;
      return tpl.content.querySelector('[data-lp-card]');
    });
  }
  function loadCards(handles) { return Promise.all(handles.map(loadCard)); }

  /** Resolves once Styled with has rendered its (possibly fetched) cards, so later rows can skip those products. */
  var styledReady = Promise.resolve();
  function handleFromHref(href) {
    var m = String(href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function initStyled(sec) {
    var mainRoot = $('[data-labels-pdp]');
    var sizeName = (mainRoot && mainRoot.dataset.sizeOption) || 'Size';
    var currentHandle = mainRoot && mainRoot.dataset.productHandle;
    var tabs = $$('[data-look-tab]', sec);
    var looks = $$('[data-look]', sec);

    // fallback without looks: complementary recommendations as PLP cards, skipping pieces already in Styling tips
    var recs = $('[data-recs]', sec);
    if (recs) {
      var limit = parseInt(sec.dataset.recsLimit, 10) || 4;
      var skip = {};
      if (currentHandle) skip[currentHandle] = true;
      $$('[data-tips] a[href*="/products/"]').forEach(function (a) {
        var h = handleFromHref(a.getAttribute('href'));
        if (h) skip[h] = true;
      });
      styledReady = fetch(root() + 'recommendations/products.json?product_id=' + sec.dataset.productId + '&limit=10&intent=complementary')
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) {
          var list = (d.products || []).filter(function (p) { return p && !skip[p.handle]; }).slice(0, limit);
          return loadCards(list.map(function (p) { return p.handle; }));
        })
        .then(function (cards) {
          var grid = $('[data-recs-grid]', recs);
          cards.forEach(function (card) { if (card) grid.appendChild(card); });
          if (!grid.children.length) { sec.hidden = true; return; }
          recs.hidden = false;
        })
        .catch(function () { sec.hidden = true; });
    }
    if (!looks.length) return;

    function activate(panel, index) {
      $$('[data-hotspot]', panel).forEach(function (h) { h.classList.toggle('is-active', h.dataset.hotspot === String(index)); });
      $$('[data-hotspot-card]', panel).forEach(function (c) { c.classList.toggle('is-active', c.dataset.hotspotCard === String(index)); });
      $$('[data-look-item]', panel).forEach(function (r) { r.classList.toggle('is-active', r.dataset.lookItem === String(index)); });
    }
    looks.forEach(function (panel) {
      $$('[data-hotspot]', panel).forEach(function (h) {
        h.addEventListener('click', function () { activate(panel, h.dataset.hotspot); track('labels_look_hotspot', { index: h.dataset.hotspot }); });
      });
      $$('[data-look-item]', panel).forEach(function (r) {
        r.addEventListener('click', function (e) { if (!e.target.closest('a,select')) activate(panel, r.dataset.lookItem); });
      });
    });

    var hydrated = {};
    function hydrate(panel) {
      var key = panel.dataset.look;
      if (hydrated[key]) return;
      hydrated[key] = true;
      $$('[data-look-item]', panel).forEach(function (row) { hydrateItem(panel, row); });
    }

    function updateTotal(panel) {
      var total = 0;
      $$('[data-look-item]', panel).forEach(function (row) {
        if (row.dataset.soldout === 'true') return;
        var select = $('[data-item-size]', row);
        var price = parseInt(row.dataset.price, 10) || 0;
        if (select && !select.hidden && select.selectedOptions[0] && select.selectedOptions[0].dataset.price) {
          price = parseInt(select.selectedOptions[0].dataset.price, 10);
        }
        total += price;
      });
      var out = $('[data-look-total]', panel);
      if (out) out.textContent = fmt(total);
    }

    function hydrateItem(panel, row) {
      fetchProduct(row.dataset.handle).then(function (p) {
        if (!p) return;
        var note = $('[data-item-note]', row);
        var select = $('[data-item-size]', row);
        var idx = sizeOptionIndex(p, sizeName);
        var onlyDefault = p.variants.length === 1 && /default title/i.test(p.variants[0].title || '');
        var avail = p.variants.filter(function (v) { return v.available; });
        row.dataset.product = p.handle;
        if (!avail.length) {
          row.dataset.soldout = 'true';
          note.textContent = S.soldOut;
          updateTotal(panel);
          return;
        }
        if (onlyDefault) {
          row.dataset.variant = avail[0].id;
          row.dataset.price = avail[0].price;
          if (row.dataset.handle === currentHandle) note.textContent = S.thisPiece;
          updateTotal(panel);
          return;
        }
        var values = p.variants.map(function (v) { return variantSizeValue(v, idx); });
        var sug = suggestSize(row.dataset.type, values);
        var sugVariant = sug && avail.filter(function (v) { return variantSizeValue(v, idx) === sug.value; })[0];
        var html = (avail.length > 1 ? '<option value="">' + esc(S.selectSize) + '</option>' : '');
        avail.forEach(function (v) {
          html += '<option value="' + v.id + '" data-price="' + v.price + '" data-size="' + esc(variantSizeValue(v, idx)) + '">' + esc(variantSizeValue(v, idx)) + '</option>';
        });
        select.innerHTML = html;
        select.hidden = false;
        if (avail.length === 1) {
          select.value = String(avail[0].id);
          note.textContent = t(S.onlyLeft, { size: variantSizeValue(avail[0], idx) });
        } else if (sugVariant) {
          select.value = String(sugVariant.id);
          note.textContent = t(S.inYourSize, { size: sug.value });
        } else {
          note.textContent = row.dataset.handle === currentHandle ? S.thisPiece : S.inStock;
        }
        select.addEventListener('change', function () { updateTotal(panel); });
        updateTotal(panel);

        // keep the "this piece" row in sync with the size chosen in the buy box
        if (row.dataset.handle === currentHandle) {
          document.addEventListener('labels:variant-change', function (e) {
            var size = e.detail && e.detail.size;
            if (!size) return;
            var match = avail.filter(function (v) { return variantSizeValue(v, idx) === size; })[0];
            if (match) { select.value = String(match.id); updateTotal(panel); }
          });
        }
      });
    }

    function showLook(index) {
      tabs.forEach(function (tab) {
        var on = tab.dataset.lookTab === String(index);
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      looks.forEach(function (panel) {
        var on = panel.dataset.look === String(index);
        panel.hidden = !on;
        if (on) hydrate(panel);
      });
    }
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () { showLook(tab.dataset.lookTab); track('labels_look_tab', { index: tab.dataset.lookTab }); });
    });
    showLook(0);

    // add look
    $$('[data-add-look]', sec).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.closest('[data-look]');
        var err = $('[data-look-error]', panel);
        err.hidden = true;
        var items = [];
        var records = [];
        var rows = $$('[data-look-item]', panel);
        for (var i = 0; i < rows.length; i++) {
          var row = rows[i];
          if (row.dataset.soldout === 'true') continue;
          var select = $('[data-item-size]', row);
          var id = null;
          var size = null;
          if (select && !select.hidden) {
            if (!select.value) {
              err.textContent = t(S.selectSizeFor, { name: $('.labels-look__name', row).textContent });
              err.hidden = false;
              select.focus();
              return;
            }
            id = select.value;
            size = select.selectedOptions[0].dataset.size;
          } else if (row.dataset.variant) {
            id = row.dataset.variant;
          }
          if (id) {
            items.push({ id: parseInt(id, 10), quantity: 1 });
            if (size) records.push({ type: row.dataset.type, brand: row.dataset.brand, value: size });
          }
        }
        if (!items.length) { err.textContent = S.nothingToAdd; err.hidden = false; return; }
        btn.disabled = true;
        cartAdd(items).then(function (cart) {
          records.forEach(recordSize);
          track('labels_look_add', { count: items.length, look: panel.dataset.look });
          document.dispatchEvent(new CustomEvent('labels:cart-add', { detail: { items: cart.items || [cart], source: 'look' } }));
          if (mainRoot && mainRoot.dataset.afterAdd === 'cart_page') { window.location.href = cartUrl(); return; }
          toast('<span>' + esc(S.addedLook) + '</span><a href="' + esc(cartUrl()) + '">' + esc(S.viewCart) + '</a>');
        }).catch(function () { err.textContent = S.cartError; err.hidden = false; })
          .then(function () { btn.disabled = false; });
      });
    });
  }

  /* ------------------------------------------------------------------ trail */
  function initTrail(sec) {
    var current = sec.dataset.current;
    var limit = Math.min(parseInt(sec.dataset.limit, 10) || 10, 10);
    var list = store.get(KEY_TRAIL, []).filter(function (x) { return x.handle !== current; }).slice(0, limit);
    if (!list.length) return;
    loadCards(list.map(function (x) { return x.handle; })).then(function (cards) {
      var grid = $('[data-trail-grid]', sec);
      var shown = 0;
      cards.forEach(function (card, i) {
        if (!card) return;
        var snap = list[i];
        card.addEventListener('click', function () { track('labels_trail_click', { handle: snap.handle }); });
        // image swiping inside a card fights the swipe between cards on mobile
        $$('slideshow-component', card).forEach(function (s) { s.setAttribute('mobile-disabled', ''); });
        grid.appendChild(card);
        shown++;
      });
      if (shown) sec.hidden = false;
    });
  }

  /* ------------------------------------------------------- you might also like */
  /** 'm', 'w', 'u' (unisex: both or gender_unisex) or '' from product tags (gender_male, male, gender_female, female). */
  function deptOfTags(tags) {
    var set = {};
    (Array.isArray(tags) ? tags : String(tags || '').split(',')).forEach(function (x) { set[String(x).trim().toLowerCase()] = true; });
    var m = set.gender_male || set.male, w = set.gender_female || set.female;
    if (set.gender_unisex || (m && w)) return 'u';
    return m ? 'm' : w ? 'w' : '';
  }
  /** Department to show: Man/Woman picked in search, else this product's gender, else the one browsed most (2+ more). */
  function visitorDept(productDept) {
    var prof = store.get('labels-search:profile', null);
    if (prof && prof.deptSet && (prof.dept === 'm' || prof.dept === 'w')) return prof.dept;
    if (productDept === 'm' || productDept === 'w') return productDept;
    var n = { m: 0, w: 0 };
    store.get(KEY_TRAIL, []).forEach(function (x) { if (x && n[x.dept] != null) n[x.dept]++; });
    if (n.m - n.w >= 2) return 'm';
    if (n.w - n.m >= 2) return 'w';
    return '';
  }
  function getJson(url) {
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .catch(function () { return { products: [] }; });
  }
  /** Brand links (breadcrumb, buy box, brand block) to the men or women brand page of the visitor's department. */
  function initBrandLinks() {
    var mainRoot = $('[data-labels-pdp]');
    var dept = visitorDept(mainRoot ? mainRoot.dataset.productDept : '');
    if (!dept) return;
    $$('a[data-brand-m]').forEach(function (a) {
      var url = dept === 'm' ? a.dataset.brandM : a.dataset.brandW;
      if (url) a.setAttribute('href', url);
    });
    var trail = $('nav[data-crumbs="' + dept + '"]');
    if (trail) {
      $$('nav[data-crumbs]').forEach(function (nav) { nav.hidden = nav !== trail; });
    }
  }
  function initAlsoLike(sec) {
    var limit = parseInt(sec.dataset.limit, 10) || 8;
    var mainRoot = $('[data-labels-pdp]');
    var current = mainRoot && mainRoot.dataset.productHandle;
    var dept = visitorDept(mainRoot ? mainRoot.dataset.productDept : '');
    var other = dept === 'm' ? 'w' : dept === 'w' ? 'm' : '';
    var fits = function (p) { return !other || deptOfTags(p.tags) !== other; };
    var related = getJson(root() + 'recommendations/products.json?product_id=' + sec.dataset.productId + '&limit=' + Math.min(limit + 6, 10) + '&intent=related');
    Promise.all([related, styledReady.catch(function () {})]).then(function (res) {
      var skip = {};
      if (current) skip[current] = true;
      $$('[data-styled] a[href*="/products/"], [data-tips] a[href*="/products/"]').forEach(function (a) {
        var h = handleFromHref(a.getAttribute('href'));
        if (h) skip[h] = true;
      });
      var keep = function (p) { return p && !skip[p.handle] && fits(p); };
      var list = ((res[0] && res[0].products) || []).filter(keep).slice(0, limit);
      var deptUrl = dept === 'm' ? sec.dataset.menUrl : dept === 'w' ? sec.dataset.womenUrl : '';
      if (list.length >= limit || !deptUrl) return list;
      list.forEach(function (p) { skip[p.handle] = true; });
      var type = mainRoot && mainRoot.dataset.productType;
      var vendor = mainRoot && mainRoot.dataset.productVendor;
      return getJson(deptUrl + '/products.json?limit=50').then(function (col) {
        var rank = function (p) { return (type && p.product_type === type ? 2 : 0) + (vendor && p.vendor === vendor ? 1 : 0); };
        var inStock = function (p) { return (p.variants || []).some(function (v) { return v.available; }); };
        var extra = ((col && col.products) || []).filter(function (p) { return keep(p) && inStock(p); })
          .map(function (p, i) { return { p: p, r: rank(p), i: i }; })
          .sort(function (a, b) { return b.r - a.r || a.i - b.i; })
          .map(function (x) { return x.p; });
        return list.concat(extra).slice(0, limit);
      });
    }).then(function (list) {
      if (!list || !list.length) return;
      return loadCards(list.map(function (p) { return p.handle; })).then(function (cards) {
        var grid = $('[data-alsolike-grid]', sec);
        var shown = 0;
        cards.forEach(function (card, i) {
          if (!card) return;
          var handle = list[i].handle;
          card.addEventListener('click', function () { track('labels_related_click', { handle: handle }); });
          grid.appendChild(card);
          shown++;
        });
        if (shown) sec.hidden = false;
      });
    });
  }

  /* -------------------------------------------------------------------- faq */
  /** FAQ accordion in the buy box (snippets/labels-pdp-faq.liquid). */
  function initFaq(rootEl) {
    var box = $('[data-faq]', rootEl);
    if (!box) return;
    var items = $$('[data-faq-item]', box);
    var more = $('[data-faq-more]', box);
    if (more) {
      more.addEventListener('click', function () {
        $$('[data-faq-extra]', box).forEach(function (el) { el.hidden = false; });
        more.hidden = true;
        track('labels_faq_show_all', { count: items.length });
      });
    }
    items.forEach(function (el, i) {
      el.addEventListener('toggle', function () { if (el.open) track('labels_faq_open', { index: i + 1 }); });
    });
  }

  /* -------------------------------------------------------------------- ask */
  function initAsk(sec) {
    var endpoint = sec.dataset.endpoint;
    var faqItems = $$('[data-faq-item]');
    var input = $('[data-ask-input]', sec);
    var answerBox = $('[data-ask-answer]', sec);
    var answerText = $('[data-ask-answer-text]', sec);

    function highlight(question) {
      var hit = null;
      faqItems.forEach(function (el) {
        var on = el.dataset.q === question;
        el.classList.toggle('is-highlight', on);
        if (on) hit = el;
      });
      if (hit) {
        hit.hidden = false;
        hit.open = true;
      }
      if (hit && hit.scrollIntoView) hit.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return !!hit;
    }
    function ask(question) {
      question = (question || '').trim();
      if (!question) return;
      track('labels_ask', { question: question, handle: sec.dataset.handle });
      var matched = highlight(question);
      if (!endpoint) return;
      if (matched) { answerBox.hidden = true; return; }
      answerBox.hidden = false;
      answerText.textContent = S.askThinking;
      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ handle: sec.dataset.handle, question: question, locale: document.documentElement.lang || 'en' })
      }).then(function (r) { if (!r.ok) throw new Error('ask'); return r.json(); })
        .then(function (j) { answerText.textContent = j.answer || S.askError; })
        .catch(function () { answerText.textContent = S.askError; });
    }
    $$('[data-ask-chip]', sec).forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (input) input.value = chip.dataset.askChip;
        ask(chip.dataset.askChip);
      });
    });
    var form = $('[data-ask-form]', sec);
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); ask(input.value); });
  }

  /* ------------------------------------------------------------------- init */
  function once(el, fn) {
    if (el.__labelsReady) return;
    el.__labelsReady = true;
    fn(el);
  }
  function init() {
    var main = $('[data-labels-pdp]');
    if (main) once(main, function (el) { initGallery(el); initFitSheet(el, initBuybox(el)); initFaq(el); });
    $$('[data-styled]').forEach(function (el) { once(el, initStyled); });
    $$('[data-trail]').forEach(function (el) { once(el, initTrail); });
    $$('[data-ask]').forEach(function (el) { once(el, initAsk); });
    $$('[data-alsolike]').forEach(function (el) { once(el, initAlsoLike); });
    initBrandLinks();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: re-initialise sections that were re-rendered
  document.addEventListener('shopify:section:load', init);
})();
